// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectAdminURL } from 'src/modules/config';
import { pathjoin } from 'src/modules/pathjoin';

import { UserActionRow } from './UserActionRow';

function NoRenewablesRow(): React.MixedElement {
  const { __ } = useTranslator();

  const adminURL = useAppSelector(selectAdminURL);
  const href = pathjoin(adminURL, 'dashboard', 'search');

  return (
    <UserActionRow
      href={href}
      message={__('No products to renew within the next 2 months.')}
      buttonLabel={__('See dashboard')}
    />
  );
}

export default NoRenewablesRow;
